import React, { useState, useEffect } from 'react'
import { Tag, Input, Table, Modal, message, Upload, Button, Empty, Form, Image, Cascader, Select } from "antd";
import { UploadOutlined, PlusOutlined } from '@ant-design/icons';
import InspectionApi from '@api/inspectionnew'
import DepartmentApi from '@api/department'
import SearchForm from '@components/SearchForm'
import HandleButton from '@components/HandleButton'
import { connect } from 'react-redux'
import { getStationData, toolMouseTip } from '@utils/common'
const { TextArea } = Input;
import AddModel from './add'
import '../style.scss'
const StatusData = ['待处理', '处理中', '完成', '关闭']
const colorStatus = ['#FF3819', '#2db7f5', '#87d068', '#BDBDBD']
const InspectionCom = (props) => {
  const [transferForm] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [editVisible, setEditVisible] = useState(false)
  const [rowParams, setRowParams] = useState()
  const [resultVisibel, setResultVisibel] = useState(false)
  const [handleImageUrls, setHandleImageUrls] = useState([])
  const [handleResult, setHandleResult] = useState('')
  const [resultId, setResultId] = useState()
  const [detailVisible, setDetailVisible] = useState(false)
  const [detailInfo, setDetailInfo] = useState({})
  const [instruDetailImgVisibel, setInstruDetailImgVisibel] = useState(false)
  const [deptList, setDeptList] = useState([])
  const [personList, setPersonList] = useState([])
  const [transferStationId, setTransferStationId] = useState('')

  const [cascaderLs, setCascaderLs] = useState([{
    label: '实际处理人',
    name: 'handleUserId',
    span: 8,
    labelCol: 6,
    options: []
  }])

  // 查询参数
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  })
  const [total, setTotal] = useState(0)


  // 转单弹出层
  const [transferVisibel, setTransferVisibel] = useState(false)
  const [transferId, setTransferId] = useState()
  // 搜索
  const [inputList] = useState([])
  const [dateSearch] = useState([])
  const [selectList, setSelectList] = useState()

  const [stationData, setStationData] = useState()

  useEffect(() => {
    getStationList()
    return () => { }
  }, [])
  // 获取厂站列表
  const getStationList = () => {
    let data = getStationData(props.userInfo.stationIds ? props.userInfo.stationIds : '-1', props.userInfo.stationAliasName)
    setSelectList([
      {
        attr: { allowClear: true },
        label: '来源类型:',
        name: "sourceType",
        message: "请选择来源类型",
        options: [
          {
            title: '缺陷单',
            value: 0
          },
          {
            title: '工单',
            value: 1
          }
        ],
        span: 8,
        labelCol: 6,
      },
      {
        attr: { allowClear: true },
        label: '厂站:',
        name: "stationId",
        message: "请选择厂站",
        options: data,
        span: 8,
        labelCol: 6,
        change: (e) => changeSearchStation(e)
      },
      {
        attr: { allowClear: true },
        label: '状态:',
        name: "handleStatus",
        message: "请选择状态",
        options: [
          {
            title: '待处理',
            value: 0
          },
          {
            title: '处理中',
            value: 1
          },
          {
            title: '完成',
            value: 2
          },
          {
            title: '关闭',
            value: 3
          }
        ],
        span: 8,
        labelCol: 6
      }
    ])
    setStationData(data)
  }

  useEffect(() => {
    listByRole()
    return () => { }
  }, [searchParams])

  const listByRole = () => {
    setLoading(true)
    InspectionApi.instructOrder({ ...searchParams, }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setData(res.data.data || [])
        setTotal(res.data.total)
      }
    })
  }

  const transferShow = async (id, stationId) => {
    // 查询部门
    const res = await DepartmentApi.getDeptForTree({})
    if (!res.status) return
    const dept = getTreeData(res.data)
    setDeptList(dept)
    setTransferVisibel(true)
    setTransferId(id)
    setTransferStationId(stationId)
  }

  // 递归处理数据
  const getTreeData = (data) => {
    for (var i = 0; i < data.length; i++) {
      if (data[i].children.length < 1) {
        data[i].children = null
        data[i].label = data[i].name
        data[i].value = data[i].id
      } else {
        data[i].label = data[i].name
        data[i].value = data[i].id
        getTreeData(data[i].children)
      }
    }
    return data
  }

  // 切换部门查询部门负责人
  const changeDept = (e) => {
    if (!e) return
    let params = {
      deptId: e[e.length - 1],
      stationId: transferStationId,
      containDeptHeaders: 1
    }
    DepartmentApi.getUsersByDeptId(params).then(res => {
      if (res.status !== '0') return
      setPersonList(res.data)
    })
  }

  // 上传前进行图片限制处理
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('图片格式不正确!');
    }
    const isLt2M = file.size / 1024 / 1024 < 7;
    if (!isLt2M) {
      message.error('图片最大7M!');
    }
    return isJpgOrPng && isLt2M;
  }

  // 指令单详情
  const getInfo = (id) => {
    InspectionApi.instructOrderInfo({ id }).then(res => {
      if (res.status !== '0') return
      setDetailInfo(res.data)
      setDetailVisible(true)
    })
  }

  const uploadResultImg = (info) => {
    const { file } = info
    if (file.status === 'done') {
      const { response: res } = file
      if (res.status !== '0') return
      setHandleImageUrls([...handleImageUrls, res.data.url])
    }
  }

  const removeResultImg = (info) => {
    const { response: res } = info
    const url = res.data.url
    const params = handleImageUrls
    const index = params.findIndex(item => item === url)
    params.splice(index, 1)
    setHandleImageUrls([...params])
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    if (paramsObj.handleUserId) {
      paramsObj.handleUserId = paramsObj.handleUserId[paramsObj.handleUserId.length - 1]
    }
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1
    }
    setSearchParams(params)
  }

  // 提交指令单结果
  const submiteResult = () => {
    if (!handleResult) return message.error('请填写指令单结果')
    InspectionApi.submiteInstructOrder({ id: resultId, handleResult: handleResult, handleImageUrls }).then(res => {
      if (res.status !== '0') return
      setHandleImageUrls([])
      setResultVisibel(false)
      setHandleResult('')
      message.success('提交成功')
      listByRole()
    })
  }

  // 提交转单
  const submiteTransfer = () => {
    transferForm.validateFields().then(values => {
      if (!values) return
      const params = {
        businessId: transferId,
        type: 1,
        ...values
      }
      InspectionApi.transferInstructOrder(params).then(res => {
        if (res.status !== '0') return
        transferForm.resetFields()
        setTransferVisibel(false)
        message.success('转单成功')
        listByRole()
      })
    })
  }

  // 
  const closeTransfer = () => {
    transferForm.resetFields()
    setTransferVisibel(false)
  }

  const cancel = () => {
    setD - elVisible(false)
    // setParams({})
  }
  // 改变状态
  const handleConfirm = (id, status) => {
    if (status == 3) {
      InspectionApi.orderComplate(id).then(res => {
        if (res.status === '0') {
          message.success('完成成功')
          listByRole()
        }
      })
    }
    if (status == 4) {
      InspectionApi.orderDelivery(id).then(res => {
        if (res.status === '0') {
          message.success('交付成功')
          listByRole()
        }
      })
    }

  }

  const closeOrder = ({ id }) => {
    InspectionApi.closeInstructOrder({ id }).then(res => {
      if (res.status === '0') {
        message.success('关闭成功')
        listByRole()
      }
    })
  }

  const changeSearchStation = (e) => {
    DepartmentApi.getUserByStationId(e).then(res => {
      res.data && res.data.map(item => {
        item.value = item.roleId
        item.label = item.roleName
        item.children = item.users.map(subItem => {
          return {
            value: subItem.userId,
            label: subItem.userName
          }
        })
      })
      setCascaderLs([{
        label: '实际处理人',
        name: 'handleUserId',
        span: 8,
        labelCol: 6,
        options: res.data
      }])
    })
  }

  const btnList = [{
    title: "新增",
    type: 'primary',
    visible: props.userInfo.btnResources.indexOf('instruct:order:add') === -1 ? false : true,
    icon: <PlusOutlined />,
    onClick: () => {
      setEditVisible(true)
      setRowParams(null)
    }
  }]

  const columns = [
    {
      title: '标题',
      dataIndex: 'instructTitle',
      align: 'center',
      key: 'instructTitle',
      render: _t => toolMouseTip(_t, 20)
    },
    {
      title: '指令内容',
      dataIndex: 'instructContent',
      align: 'center',
      key: 'instructContent',
      render: _t => toolMouseTip(_t, 20)
    },
    {
      title: '所属厂站',
      dataIndex: 'stationAliasName',
      align: 'center',
      key: 'stationAliasName',
    },
    {
      title: '处理人',
      dataIndex: 'handleUserNames',
      align: 'center',
      key: 'handleUserNames',
    },
    {
      title: '实际处理人',
      dataIndex: 'handleUserName',
      align: 'center',
      key: 'handleUserName',
      render: _t => _t ? _t : '-'
    },
    {
      title: '开始日期',
      dataIndex: 'beginTime',
      align: 'center',
      key: 'beginTime'
    },
    {
      title: '结束日期',
      dataIndex: 'endTime',
      align: 'center',
      key: 'endTime'
    },
    {
      title: '状态',
      dataIndex: 'handleStatus',
      align: 'center',
      key: 'handleStatus',
      render: val => <Tag color={colorStatus[val - 0]}>{StatusData[val - 0]}</Tag>
    },
    {
      title: '超时状态',
      dataIndex: 'timeoutStatus',
      align: 'center',
      key: 'timeoutStatus',
      render: _t => _t == 1 ? <Tag color="#FF3819">超时</Tag> : <Tag color="#2db7f5">未超时</Tag>
    },
    {
      title: '操作',
      key: 'operation',
      width: '260px',
      fixed: 'right',
      render: (obj, record) => {
        return (
          <>
            {
              props.userInfo.btnResources.indexOf('instruct:order:transfer') !== -1 &&
              (record.handleStatus !== 2 && record.handleStatus !== 3) && <Button size='small' onClick={() => { transferShow(record.id, record.stationId) }} type="primary">转单</Button>
            }
            {
              props.userInfo.btnResources.indexOf('instruct:order:submit') !== -1 &&
              (record.handleStatus !== 2 && record.handleStatus !== 3) && <Button size='small' className='success' onClick={() => (setResultVisibel(true), setResultId(record.id))} type="primary" style={{ marginLeft: 10 }}>提交</Button>
            }
            {
              props.userInfo.btnResources.indexOf('instruct:order:close') !== -1 &&
              (record.handleStatus !== 2 && record.handleStatus !== 3) && <Button size='small' type="primary" className='deleteBtn' style={{ marginLeft: 10 }} onClick={() => closeOrder(record)}>关闭</Button>
            }
            {
              props.userInfo.btnResources.indexOf('instruct:order:info') !== -1 &&
              <Button size='small' type="primary" style={{ marginLeft: 10 }} onClick={() => getInfo(record.id)}>详情</Button>
            }
          </>
        )
      }
    }
  ]
  return (
    <div className='baseContent boundary'>
      <div className='title'>
        <div style={{ marginLeft: '24px' }}>
          <SearchForm span={6} dateSearch={dateSearch} cascaderLs={cascaderLs} inputList={inputList} selectList={selectList} onSearch={search} />
        </div>
        <HandleButton btnList={btnList} btnStyle={{ padding: '0 24px 20px', textAlign: 'right' }} />
        <div >
          <Table
            className='Table'
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: total
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
        <Modal
          title="指令单详情"
          width={600}
          open={detailVisible}
          onOk={() => setDetailVisible(false)}
          onCancel={() => setDetailVisible(false)}
        >
          <div className='instru-detail'>
            <div className='defect-detail-td'>
              <div className='defect-detail-title'>{detailInfo.instructTitle}</div>
              <div className='defect-detail-status'><Tag color={colorStatus[detailInfo.handleStatus - 0]}>{StatusData[detailInfo.handleStatus - 0]}</Tag></div>
            </div>
            <div className='defect-detail-bd'>
              <div className='defect-detail-bd-item'>
                <div className='defect-detail-item-lable'>指令单内容：</div>
                <div className='defect-detail-item-desc'>{detailInfo.instructContent}</div>
              </div>
              <div className='defect-detail-bd-item'>
                <div className='defect-detail-item-lable'>所属厂站：</div>
                <div className='defect-detail-item-desc'>{detailInfo.stationAliasName}</div>
              </div>
              <div className='defect-detail-bd-item'>
                <div className='defect-detail-item-lable'>处理人: </div>
                <div className='defect-detail-item-desc'>{detailInfo.handleUserNames}</div>
              </div>
              <div className='defect-detail-bd-item'>
                <div className='defect-detail-item-lable'>实际处理人: </div>
                <div className='defect-detail-item-desc'>{detailInfo.handleUserName}</div>
              </div>
              <div className='defect-detail-bd-item'>
                <div className='defect-detail-item-lable'>来源类型: </div>
                <div className='defect-detail-item-desc'>{detailInfo.sourceType ? '工单' : '缺陷单'}</div>
              </div>
              <div className='defect-detail-bd-item'>
                <div className='defect-detail-item-lable'>关联描述: </div>
                <div className='defect-detail-item-desc'>{detailInfo.sourceDesc}</div>
              </div>
              <div className='defect-detail-bd-item'>
                <div className='defect-detail-item-lable'>开始时间: </div>
                <div className='defect-detail-item-desc'>{detailInfo.beginTime}</div>
              </div>
              <div className='defect-detail-bd-item'>
                <div className='defect-detail-item-lable'>结束时间: </div>
                <div className='defect-detail-item-desc'>{detailInfo.endTime}</div>
              </div>
              <div className='defect-detail-bd-item'>
                <div className='defect-detail-item-lable'>超时状态: </div>
                <div className='defect-detail-item-desc'>{detailInfo.timeoutStatus == 1 ? '超时' : '未超时'}</div>
              </div>
              <div className='defect-detail-bd-item'>
                <div className='defect-detail-item-lable'>处理结果: </div>
                <div className='defect-detail-item-desc'>{detailInfo.handleResult ? detailInfo.handleResult : '-'}</div>
              </div>
              <div className='defect-detail-bd-img'>
                <div className='defect-detail-item-lable'>图片展示</div>
                {
                  detailInfo.handleImageUrls && detailInfo.handleImageUrls.length > 0 ? <div className='defect-detail-item-imglist'>
                    <Image
                      preview={{
                        visible: false,
                      }}
                      width={200}
                      src={detailInfo.handleImageUrls[0]}
                      onClick={() => setInstruDetailImgVisibel(true)}
                    />

                    <div style={{ display: 'none' }}>
                      <Image.PreviewGroup
                        preview={{
                          visible: instruDetailImgVisibel,
                          onVisibleChange: (vis) => setInstruDetailImgVisibel(vis),
                        }}
                      >
                        {
                          detailInfo.handleImageUrls.map((item, index) => {
                            return <Image src={item} key={index} />
                          })
                        }
                      </Image.PreviewGroup>
                    </div>

                  </div> : <Empty description="暂无图片" />
                }
              </div>
            </div>
          </div>
        </Modal>
        {
          resultVisibel && <Modal
            title='提交指令单结果'
            width={600}
            open={resultVisibel}
            onCancel={() => (setResultVisibel(false), setHandleResult(''), setHandleImageUrls([]))}
            onOk={submiteResult}
          >
            <Form
              layout="horizontal"
            >
              <Form.Item label='指令单结果' required>
                <TextArea rows={3} placeholder="请输入指令单结果" onChange={(e) => { setHandleResult(e.target.value) }} />
              </Form.Item>
              <Form.Item label='上传图片'>
                <Upload
                  name='file'
                  action={window.globalConfig.UPLOADER}
                  headers={{ authorization: sessionStorage.getItem('token') }}
                  beforeUpload={(e) => beforeUpload(e)}
                  onChange={(e) => uploadResultImg(e)}
                  onRemove={(e) => removeResultImg(e)}
                >
                  <Button icon={<UploadOutlined />}>上传图片</Button>
                </Upload>
              </Form.Item>
            </Form>
          </Modal>
        }
        {/* 转单 */}
        <Modal
          title='转单'
          width={600}
          open={transferVisibel}
          onCancel={closeTransfer}
          onOk={submiteTransfer}
        >
          <Form
            name="basic"
            form={transferForm}
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 14,
            }}
            autoComplete="off"
          >
            <Form.Item label='负责部门' name="deptId" rules={[{ required: true, message: '请选择负责部门' }]}>
              <Cascader options={deptList} onChange={(e) => { changeDept(e) }} placeholder="请选择" />
            </Form.Item>
            <Form.Item label='现操作人' name="currentOperator" rules={[{ required: true, message: '请选择现操作人' }]}>
              <Select placeholder="请选择现操作人">
                {personList.length > 0 && personList.map(item => {
                  return <Select.Option value={item.id} key={item.id}>{item.realName}</Select.Option>
                })}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
        {editVisible && <AddModel stationData={stationData} visible={editVisible} title='新增指令单' formData={rowParams} cancel={(bool) => { setEditVisible(false); bool && listByRole() }} />}
      </div>
    </div >
  )
}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
};

export default connect(mapStateToProps)(InspectionCom)
